import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-button',
  templateUrl: './open-button.component.html',
  styleUrls: ['./open-button.component.scss']
})
export class OpenButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
